import { defineMessages } from '@faceup/localization'
import { CaseStatusGroup } from '@faceup/utils'

// Enum-derived keys keep their PascalCase enum values as leaf ids so
// `reportStatusMessages[groupName]` lookups stay valid. Phase 3 (ENG-2030)
// applies the lowercase-first transform across all enum maps symmetrically.
const idToMessage = <S extends string>(id: S) => ({ id, defaultMessage: '' })

export const sharedMessages = defineMessages('followUp.shared', [
  { id: 'apiError', defaultMessage: '' },
  { id: 'attachmentsTooManyFiles', defaultMessage: '' },
  { id: 'attachmentsTooLargeFile', defaultMessage: '' },
  { id: 'metadataRemoved', defaultMessage: '' },
  { id: 'metadataUnableToRemove', defaultMessage: '' },
  { id: 'unsupportedMimetype', defaultMessage: '' },
  { id: 'submit', defaultMessage: '' },
  { id: 'save', defaultMessage: '' },
  { id: 'savedMessage', defaultMessage: '' },
  { id: 'add', defaultMessage: '' },
  { id: 'invalidInputError', defaultMessage: '' },
  { id: 'continue', defaultMessage: '' },
  { id: 'fieldRequired', defaultMessage: '' },
  { id: 'selectPlaceholder', defaultMessage: '' },
  { id: 'encryptionError', defaultMessage: '' },
  { id: 'globalNameLabel', defaultMessage: '' },
  { id: 'send', defaultMessage: '' },
  { id: 'delete', defaultMessage: '' },
  { id: 'download', defaultMessage: '' },
  { id: 'ok', defaultMessage: '' },
  { id: 'cancel', defaultMessage: '' },
  { id: 'bio', defaultMessage: '', values: { name: true } },
  { id: 'partnerBio', defaultMessage: '', values: { name: true } },
] as const)

export const reportStatusMessages = defineMessages(
  'followUp.reportStatus',
  Object.values(CaseStatusGroup).map(idToMessage)
)
